import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './../../styles/admin/clientes_edit.css';
import * as globals from './../../components/GlobalScripts.js';
import { useNavigate } from 'react-router-dom';

const Admin_clientes_edit = () => {
    let path_api = localStorage.getItem('path_api');
    const { id } = useParams();
    const isNew = id === 'new';

    const [email, setEmail] = useState('');
    const [nombre, setNombre] = useState('');
    const [rol, setRol] = useState(1);
    const [keylogin, setKeylogin] = useState('');
    const [createAt, setCreateAt] = useState('');
    const [address, setAddress] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        if (!isNew) {
            loadCliente();
        }
    }, [id]);

    const loadCliente = () => {
        globals.openViewCharge();
        globals.validateSession();
        axios.post(`${path_api}/admin/clientes_edit.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id: id
        }).then(response => {
            if (response.data.mensaje === 'success' && response.data.cliente) {
                const c = response.data.cliente;
                setEmail(c.email);
                setNombre(c.nombre);
                setRol(c.rol || 1);
                setKeylogin(c.keylogin);
                setCreateAt(c.createAt || '');
                setAddress(c.direccion);
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se pudo cargar el cliente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al cargar cliente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const saveCliente = async () => {
        if (!email || !nombre) {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Debes completar todos los campos obligatorios", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            return;
        }

        globals.validateSession();
        globals.openViewCharge();
        await axios.post(`${path_api}/admin/clientes_edit.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id: isNew ? 'new' : id,
            email,
            nombre,
            rol
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({ type: "success", msg_title: "Éxito", msg: "Cliente guardado correctamente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
                if (isNew) {
                    navigate(`/admin/clientes/${response.data.id}`);
                }
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se pudo guardar el cliente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al guardar cliente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    const returnPage = () => {
        navigate(`/admin/clientes`);
    };

    return (
        <>
            <h2>{isNew ? 'Nuevo cliente' : `Editando cliente: ${nombre}`}</h2>
            <div className="container-form-cliente">
                {!isNew && (
                    <div className="form-field">
                        <label>Keylogin</label>
                        <input type="text" value={keylogin} disabled />
                    </div>
                )}

                <div className="form-field">
                    <label className="requiered-input">Email</label>
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} />
                </div>

                <div className="form-field">
                    <label className="requiered-input">Nombre</label>
                    <input type="text" value={nombre} onChange={e => setNombre(e.target.value)} />
                </div>


                {keylogin != globals.get_keylogin() && (
                    <div className="form-field">
                        <label>Rol</label>
                        <select value={rol} onChange={e => setRol(parseInt(e.target.value, 10))}>
                            <option value={1}>Cliente</option>
                            <option value={2}>Manager</option>
                            <option value={3}>Dev</option>
                        </select>
                    </div>
                )}

                {!isNew && (
                    <div className="form-field">
                        <label>Fecha de Creación</label>
                        <input type="text" value={createAt} disabled />
                    </div>
                )}

                <div className="form-field">
                    <label>Dirección</label>
                    <p>{address?.direccion}</p>
                </div>

                <div className="form-field">
                    <label>Referencia</label>
                    <p>{address?.referencia}</p>
                </div>

                <div className="form-field">
                    <label>Apartamento</label>
                    <p>{address?.apartamento}</p>
                </div>

                <div className="form-field">
                    <label>Estado</label>
                    <p>{address?.estado}</p>
                </div>

                <div className="form-field">
                    <label>Ciudad</label>
                    <p>{address?.ciudad}</p>
                </div>

                <div className="form-field">
                    <label>Colonia</label>
                    <p>{address?.colonia}</p>
                </div>

                <div className="form-field">
                    <label>CP</label>
                    <p>{address?.codigoPostal}</p>
                </div>

                <div className="form-field">
                    <label>Telefono</label>
                    <p>{address?.telefono}</p>
                </div>

                <div className="actions">
                    <button onClick={returnPage} className="cancel">Regresar</button>
                    <button onClick={saveCliente}>Guardar Cliente</button>
                </div>
            </div>
        </>
    );
};

export default Admin_clientes_edit;
